module.exports = __webpack_public_path__ + "static/media/gitflow.42fd0cda.png";